// ** React Imports
import { Fragment, useState , useEffect} from "react";

// ** MUI Components
import {
  Avatar,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  CircularProgress,
  Popover,
  Drawer,
  Paper,
  Select,
  TextField
} from "@mui/material";
import Radio from "@mui/material/Radio";
import MuiStep from "@mui/material/Step";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import { styled, useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Tooltip from "@mui/material/Tooltip";
import AvatarGroup from "@mui/material/AvatarGroup";
import Collapse from "@mui/material/Collapse";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
} from "@mui/x-data-grid";

// ** Icon Imports
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../../../components/icon";

// ** Custom Component Imports
import StepperCustomDot from "../../../components/Stepper/StepperCustomDot";
import CustomAvatar from "../../../components/mui/avatar";
import CustomTextField from "../../../components/mui/text-field";
import CustomChip from "../../../components/mui/chip";
import CustomAutocomplete from "components/mui/autocomplete";

import FormHelperText from '@mui/material/FormHelperText';
// ** Utils Import
import { hexToRGBA } from "../../../components/utils/hex-to-rgba";

// ** Styled Component
import StepperWrapper from "../../../components/styles/mui/stepper";

import { unitsOfMeasure, linearUnits, volumetric, areaUnits,calculateAreaOrVolume,uomCalculations } from "../../../components/logic/UnitOfMeasurement";
import { SavePropertyArea } from "../logic/SavePropertyArea";

const AddPropertyAreaDialog = ({
    open,
    handleClose,
    jobsite,
    navigate,
    propertyArea,
    setPropertyArea,
    areaMeasurement,
    setAreaMeasurement,
    clearAreaMeasurement,
    toast,
    setLoading,
    fetchPropertyArea,
    listOfMeasurements, 
    setListOfMeasurements,    
    propertyContent,
    onSaved,
}) => {
    // ** Hooks    
    const theme = useTheme();

    // ** States
    const [anchorElAddMeasurement, setAnchorElAddMeasurement] = useState(null);
    const [areaMeasurementIsEmpty, setAreaMeasurementIsEmpty] = useState(false);

    const openAddMeasurement = Boolean(anchorElAddMeasurement);
    const idAddMeasurement = openAddMeasurement ? 'simple-popover' : undefined;
    const [Breakdown, setBreakdown] = useState(false);

    const [propertyErrors, setPropertyErrors] = useState({});
    const [areaErrors, setAreaErrors] = useState({});
    const [isEditingMode, setIsEditingMode] = useState(false);
    const [areaIndex, setAreaIndex] = useState(-1);
    const [totalOpen, setTotalOpen] = useState(false);

    const isEditingProperty = !!propertyArea?.propertyAreaID;


    // Handle Popover
    const handleClickAddMeasurement = (event) => {      
      setIsEditingMode(false); 
      setBreakdown(false);      
      clearAreaMeasurement();      
      setAnchorElAddMeasurement(event.currentTarget);         
    };

    const handleCloseAddMeasurement = () => {
      clearAreaMeasurement();
      setAnchorElAddMeasurement(null);  
      handlePropertyChange('measurement',areaMeasurement);           
    };

    const handleBreakdown = (e) =>{
      setBreakdown(e.target.checked);           
    }

    const isNumberOnly = (input) => {
      const numberRegex = /^\d*\.?\d*$/
 
      return numberRegex.test(input);
    }

    const handleAreaMeasurement = (field, value) => {
      if(field === 'length' || field === 'width' || field === 'height'  ){
        if(isNumberOnly(value)){
          setAreaMeasurement((prevState) => ({ ...prevState, [field]: value }));   
        }
      }else if(field === 'unitOfMeasure'){
        setAreaMeasurement((prevState) => ({ ...prevState, [field]: value ,['length']: '',['width']: '',['height']: ''}));   
      }else{
        setAreaMeasurement((prevState) => ({ ...prevState, [field]: value }));   
      }                          
    };
    
    const getTotal = () =>{      
      return calculateAreaOrVolume(
        areaMeasurement?.unitOfMeasure, areaMeasurement?.length, areaMeasurement?.width, areaMeasurement?.height);               
    }
   

    const handleEditMeasurement = (event,index) => {
      setAreaIndex(index);
      setIsEditingMode(true);
      const measurementToEdit = listOfMeasurements[index];
      clearAreaMeasurement();
      setAreaMeasurement(measurementToEdit);
      setAnchorElAddMeasurement(event.currentTarget);      
    }

useEffect(()=>{
  if(jobsite?.jobsiteID > 0){
    handlePropertyChange('jobsiteID', jobsite?.jobsiteID);
  }
},[jobsite])

    const handleSaveMeasurement = () => {
      if (validateMeasurement()) {
        setListOfMeasurements((prevList) => {
          const updatedList = [...(prevList ?? [])]; 
    
          const normalizedMeasurement = {
            ...areaMeasurement,
            height: areaMeasurement?.height === "" || !Breakdown ? 0 : parseFloat(areaMeasurement?.height) || 0,
            width: areaMeasurement?.width === "" || !Breakdown ?  0 : parseFloat(areaMeasurement?.width) || 0,
            length: areaMeasurement?.length === "" || !Breakdown ? 0 : parseFloat(areaMeasurement?.length) || 0,
            total: parseFloat(areaMeasurement?.total) || 0,
          };
    
          if (isEditingMode && areaIndex >= 0 && areaIndex < updatedList.length) {
            updatedList[areaIndex] = normalizedMeasurement;
          } else {
            updatedList.push(normalizedMeasurement);
          }    
          return updatedList;
        });
    
        clearAreaMeasurement();
        handleCloseAddMeasurement();
        validateFields(0, 'measurement');
        setIsEditingMode(false);
            
        setListOfMeasurements((prevList) => {
          const measurements = Array.isArray(prevList) ? prevList : [prevList];
          handlePropertyChange('measurement', measurements);
          handlePropertyChange('jobsiteID', jobsite.jobsiteID);
          return prevList;
        });
      }
    };

    const handleDeleteMeasurement = (index) => {
      // Remove the item at the specific index from the list
      setListOfMeasurements(prevList => prevList.filter((_, i) => i !== index));
    }

const handleSaveProperty = async () => {  
  if(validateFields(0,'')){            
    try {      
      console.log("At Property ARea : ",jobsite);
      setLoading(true);
      let data = await SavePropertyArea(propertyArea,navigate,jobsite.jobsiteID)       
      if (data && !data.isError) {
        const created = data?.result || data?.data || propertyArea;
        onSaved?.(created);
        handleClose(); 
        fetchPropertyArea(jobsite?.jobsiteID,0);      
        toast.success(data.message || 'Property area saved successfully!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });        
      } else {                  
        toast.error(data.message || 'Failed to save Property Area.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      }
    } catch (error) {
      console.log('An error occurred while saving property. Please try again.');
    }finally{
      setLoading(false);
    }
  }
}

    const validateFields = (step,field) => {
      let tempErrors = {};
     
      
        if (!propertyArea.propertyAreaName && (field === '' || field==='propertyAreaName')) tempErrors.propertyAreaName = 'Property Area Name is required';
        // if((!listOfMeasurements || listOfMeasurements.length === 0) && (field === '' || field==='measurement')){
        //   tempErrors.listOfMeasurements =  'Area measurement is required';
        // }        
      setPropertyErrors(tempErrors);    
      return Object.keys(tempErrors).length === 0;
    };

    useEffect(() => {
      if (Object.keys(areaErrors).length > 0) {
        const timer = setTimeout(() => {
          setAreaErrors({});
        }, 5000);
        return () => clearTimeout(timer);
      }
    }, [areaErrors]);

    const validateMeasurement = () =>{
      let tempErrors = {};
      if(!areaMeasurement?.measurementName ) tempErrors.measurementName = 'Measurement Name is required';
      if(areaMeasurement?.total <= 0) tempErrors.total = 'Total field is required';
      if((!linearUnits.includes(areaMeasurement?.unitOfMeasure)) && Breakdown && (!areaMeasurement?.width || areaMeasurement?.width === '')) tempErrors.width = 'Width field is required';
      if((!linearUnits.includes(areaMeasurement?.unitOfMeasure)) && Breakdown && (!areaMeasurement?.length || areaMeasurement?.length === '')) tempErrors.length = 'Length field is required'; 
      if((!linearUnits.includes(areaMeasurement?.unitOfMeasure)) && Breakdown && !areaUnits.includes(areaMeasurement?.unitOfMeasure) && (!areaMeasurement?.height || areaMeasurement?.height === '')) tempErrors.height = 'Height field is required';
      if(!areaMeasurement?.unitOfMeasure) tempErrors.total = 'Select Unit of Measure';
      setAreaErrors(tempErrors);    
      return Object.keys(tempErrors).length === 0;
    }

    const handlePropertyChange = (field, value) => {
      if(field === 'propertyAreaName' ){
        validateFields();
        setPropertyArea((prevState) => ({ ...prevState, [field]: value , ['jobsiteID']: jobsite?.jobsiteID}));
      }else{
        setPropertyArea((prevState) => ({ ...prevState, [field]: value }));
      }              
    };


    useEffect(() => {
      const total = getTotal();      
      if (total !== areaMeasurement?.total) {
        handleAreaMeasurement('total', total);
      }
    }, [areaMeasurement?.length, areaMeasurement?.width, areaMeasurement?.height]);

    useEffect(() =>{
      handlePropertyChange('measurement', Array.isArray(listOfMeasurements) ? listOfMeasurements : [listOfMeasurements]);
    },[listOfMeasurements])


    return (
        <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <Typography variant="h3" fontWeight='bold'>{propertyContent.title}</Typography>
        </DialogTitle>
        <DialogContent>          
          <Grid container spacing={5}>
            <Grid item xs={12} sm={7}>
              <CustomTextField 
                label="Property Area Name" 
                value={propertyArea?.propertyAreaName}
                onChange={(e) => handlePropertyChange('propertyAreaName', e.target.value)}
                placeholder='Enter area (e.g., Back Yard, Front Yard)'
                fullWidth 
                required
                error={!!propertyErrors.propertyAreaName} 
                helperText={propertyErrors.propertyAreaName}                
                />
            </Grid>
            <Grid item xs={12} sm={5}>
            <FormControl>
                  <FormLabel
                    required
                    sx={{
                      fontSize: "13px",
                      color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.78) !important' : "rgba(47, 43, 61, 0.78)!important",
                      '& .MuiFormLabel-asterisk': {
                        color: theme.palette.error.main
                      },
                    }}
                  >
                    Property Area Type
                  </FormLabel>
                  <RadioGroup row name="jobsite-type-radio" 
                  value={propertyArea?.propertyAreaType}
                  onChange={(e) => handlePropertyChange('propertyAreaType', e.target.value)}
                  defaultValue='Indoor'>
                    <FormControlLabel
                      value="Indoor"
                      control={<Radio color='success' />}
                      label="Indoor"
                    />
                    <FormControlLabel
                      value="Outdoor"
                      control={<Radio color='success' />}
                      label="Outdoor"
                    />
                  </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={7}>
              <CustomTextField label="Description"
                placeholder='Provide a brief description (optional)' 
                fullWidth 
                multiline 
                value={propertyArea?.description}
                onChange={(e) => handlePropertyChange('description', e.target.value)}
                rows='2' 
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                <Typography variant='h5'>
                  Area Measurements
                </Typography>
                <IconButton sx={{ border: "1px solid #D9D9D9" }} size="small" onClick={handleClickAddMeasurement}>
                  <AddIcon />
                </IconButton>
                {!!propertyErrors.listOfMeasurements &&  listOfMeasurements.length === 0  && (                              
                  <FormHelperText sx={{ color: '#EA5455', mt: '2px', mb:'6px', lineHeight: 1.154,fontSize: '0.8125rem', fontWeight: 400, fontFamily: 'Lexend, Inter, Public Sans, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"' }}>
                    {propertyErrors.listOfMeasurements}
                  </FormHelperText>
                )}
                <Popover 
                id={idAddMeasurement}
                open={openAddMeasurement}
                anchorEl={anchorElAddMeasurement}
                onClose={handleCloseAddMeasurement}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >                
                <Box sx={{p: 4, maxWidth: '500px'}}>                  
                  <Grid container spacing={5}>
                    <Grid item xs={12}>
                      <TextField 
                        fullWidth
                        required
                        error={!!areaErrors.measurementName} 
                        helperText={areaErrors.measurementName} 
                        sx={{
                          color: "rgba(47, 43, 61, 0.78)!important",
                          '& .MuiFormLabel-asterisk': {
                            color: theme.palette.error.main
                          },
                        }}  
                        label='Measurement Name' 
                        value={areaMeasurement?.measurementName}
                        onChange={(e) => handleAreaMeasurement('measurementName', e.target.value)}
                      />
                    </Grid>                    
                    <Grid item xs={12} sm={6}>
                      <TextField 
                        required
                        error={!!areaErrors.total} 
                        helperText={areaErrors.total} 
                        sx={{
                          color: "rgba(47, 43, 61, 0.78)!important",
                          '& .MuiFormLabel-asterisk': {
                            color: theme.palette.error.main
                          },
                        }} 
                        fullWidth
                        type="number"
                        label='Total'
                        onFocus={(e) => e.target.select()} 
                        // pattern="^\d*\.?\d*$"
                        value={(Breakdown && !linearUnits.includes(areaMeasurement?.unitOfMeasure))? 
                          getTotal()
                          : areaMeasurement?.total}
                        onChange={(e) => handleAreaMeasurement('total', parseFloat(e.target.value) || '')}
                        disabled={Breakdown && !linearUnits.includes(areaMeasurement?.unitOfMeasure)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" sx={{ alignItems: 'center'}}>
                              {/* <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              > */}
                                {/* <CustomTextField 
                                  select                                 
                                  value={areaMeasurement?.unitOfMeasure || '0'}
                                  onChange={(e) => handleAreaMeasurement('unitOfMeasure',e.target.value)}
                                  defaultValue="0"
                                  SelectProps={{
                                    renderValue:(selected) => {
                                      if (selected === "0") {
                                        return <span>Unit</span>; 
                                      }                                    
                                      return <span>{selected}</span>;
                                    },
                                    MenuProps: {
                                      PaperProps: {
                                        style: {
                                          maxHeight: 200,
                                          overflowY: 'auto',
                                        },
                                        sx: {
                                          '&::-webkit-scrollbar': {
                                            width: '8px',
                                          },
                                          '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: 'text.secondary',
                                            borderRadius: '4px',
                                          },
                                          '&::-webkit-scrollbar-thumb:hover': {
                                            backgroundColor: 'text.primary',
                                          },
                                        },
                                      },
                                    },
                                  }}
                                  variant="standard"
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      border: "none",
                                      boxShadow: "none",
                                    },
                                  }}
                                >
                                  <MenuItem disabled value='0'>Unit</MenuItem>
                                  {unitsOfMeasure.map((unit, index) => (
                                    <MenuItem key={index} value={unit.value}>
                                      {unit.text}
                                    </MenuItem>
                                  ))}
                                </CustomTextField> */}
                                {/* {console.log('unitsOfMeasure', areaMeasurement?.unitOfMeasure)} */}
                                <Box sx={{ flexGrow: 1, minWidth: '130px' }}>
                                  <CustomAutocomplete
                                    open={totalOpen}
                                    onClose={() => setTotalOpen(false)}
                                    options={unitsOfMeasure}
                                    id='autocomplete-custom'
                                    getOptionLabel={(option) => (option?.text ? option.text : '')}
                                    onChange={(event, value) => {
                                      if (value) {
                                        handleAreaMeasurement('unitOfMeasure', value.value);
                                      }
                                    }}
                                    value={unitsOfMeasure.find((unit) => unit.value === areaMeasurement?.unitOfMeasure) || null}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    renderInput={
                                      params => 
                                        <CustomTextField 
                                          {...params} 
                                          fullWidth
                                          placeholder='Select' 
                                          value={areaMeasurement?.unitOfMeasure || '0'}
                                          onChange={(e) => handleAreaMeasurement('unitOfMeasure',e.target.value)}
                                          onClick={
                                            () => setTotalOpen(!totalOpen)
                                          }
                                          sx={{
                                            "& .MuiInputBase-root": {
                                              border: "none",
                                              boxShadow: "none",
                                            },
                                          }}
                                        />
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option.value}>
                                        {option.text}
                                      </li>
                                    )}
                                  />
                                </Box>
                                <Divider
                                  orientation="vertical"
                                  flexItem
                                  sx={{
                                    mx: 1,
                                  }}
                                />
                            {/* </Box> */}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {!linearUnits.includes(areaMeasurement?.unitOfMeasure) && (
                      <Grid item xs={6}>
                        <FormControlLabel 
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                          label='Breakdown (i.e., L x W)'
                          control={<Checkbox color='success' 
                          checked={Breakdown}                           
                          onChange={(e) => handleBreakdown(e)} 
                          />}
                        />
                    </Grid>
                    )}                    
                    {Breakdown && areaUnits.includes(areaMeasurement?.unitOfMeasure) && ( 
                      <>
                        <Grid item xs={6}>
                          <TextField 
                            error={!!areaErrors.length} 
                            helperText={areaErrors.length} 
                            required
                            fullWidth
                            label='Length' 
                            value={areaMeasurement?.length}
                            onChange={(e) => handleAreaMeasurement('length', e.target.value)}

                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField 
                            error={!!areaErrors.width} 
                            helperText={areaErrors.width}
                            required
                            fullWidth
                            label='Width' 
                            value={areaMeasurement?.width}
                            onChange={(e) => handleAreaMeasurement('width', e.target.value)}
                          />
                        </Grid>  
                      </>                                         
                    )}
                    {Breakdown && volumetric.includes(areaMeasurement?.unitOfMeasure) && (
                      <>
                        <Grid item xs={4}>
                          <TextField 
                            error={!!areaErrors.length} 
                            helperText={areaErrors.length} 
                            required
                            fullWidth
                            label='Length' 
                            value={areaMeasurement?.length}
                            onChange={(e) => handleAreaMeasurement('length', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField 
                            error={!!areaErrors.width} 
                            helperText={areaErrors.width}
                            required
                            fullWidth
                            label='Width' 
                            value={areaMeasurement?.width}
                            onChange={(e) => handleAreaMeasurement('width', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField 
                            error={!!areaErrors.height} 
                            helperText={areaErrors.height}
                            required
                            fullWidth
                            label='Height'
                            value={areaMeasurement?.height}
                            onChange={(e) => handleAreaMeasurement('height', e.target.value)} 
                          />
                        </Grid>
                      </>                                             
                    )}
                    
                    <Grid item xs={12}>
                      <Button variant='contained' color='main' sx={{ float: 'right' }} onClick={()=>{handleSaveMeasurement()}}>
                        {isEditingMode? 'Save Changes' : 'Add Measurement'}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Popover>
              </Box>
            </Grid>
            <Grid item xs={12}>                            
              {listOfMeasurements && listOfMeasurements.length > 0 ? (
                  listOfMeasurements.map((item, index) => (
                    <Box key={index} sx={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #E1E4EA', py: 2}}>
                      <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                        <Icon icon="tabler:ruler-measure-2" />
                        <Typography variant="subtitle1">{item.measurementName}</Typography>
                      </Box>
                      <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                        <Typography variant='subtitle2'>Total size</Typography>
                        <CustomChip skin={theme.palette.mode === 'dark' ? 'dark' : 'light'} color='primary' label={`${item.total} ${item.unitOfMeasure}`} sx={{fontWeight: '550'}} />
                        <IconButton onClick={(e)=>{handleEditMeasurement(e,index)}}>
                          <Icon icon="tabler:pencil"/>
                        </IconButton>
                        <IconButton color='error' onClick={()=>{handleDeleteMeasurement(index)}}>
                          <Icon icon="tabler:trash" />
                        </IconButton>
                      </Box>
                    </Box>   
                  ))):(
                    <Card>
                  <CardContent
                    sx={{
                      display: "flex",
                      textAlign: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                      p: (theme) =>
                        `${theme.spacing(9.75, 4, 9.25)} !important`,
                    }}
                  >
                    <CustomAvatar skin={theme.palette.mode === 'dark' ? 'dark' : 'light'} sx={{ mb: 2.25 }}>
                      <Icon icon="tabler:ruler-measure-2" />
                    </CustomAvatar>
                    <Typography variant="h5" sx={{ mb: 2.75 }}>
                      No Measurements added yet
                    </Typography>
                    <Typography sx={{ color: "text.secondary" }}>
                      Start adding measurements by clicking '+' on top.
                    </Typography>
                  </CardContent>
                    </Card>
                  )              
                }                                
            </Grid>            
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button
              variant="contained"
              color="info"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="main"
              onClick={handleSaveProperty}
            >
              {isEditingProperty ? 'Save Changes' : 'Save Property Area'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    )
}

export default AddPropertyAreaDialog